"use strict";
Object.defineProperty(exports, "__esModule", {
    value: !0
}), Object.defineProperty(exports, "PAGE_SIZE", {
    enumerable: !0,
    get: function() {
        return PAGE_SIZE;
    }
});
const PAGE_SIZE = 50;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zdG9yZS9hY3Rpdml0eS9wYWdlU2l6ZS50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgY29uc3QgUEFHRV9TSVpFID0gNTBcbiJdLCJuYW1lcyI6WyJQQUdFX1NJWkUiXSwibWFwcGluZ3MiOiI7OzttQ0FBYUE7OztlQUFBQTs7O0FBQU4sTUFBTUEsWUFBWSJ9